export const htmlRemove = (arg: string): string =>
  arg.replace(/(<\/?br ?\/?>)|(&nbsp;)/g, ' ').replace(/<\/?[^>]+(>|$)/g, '')
